import type { AtlasLevel } from './levels.js';

const MiB = 1024 * 1024;

/** Decoded RGBA bytes each 64-heading atlas level may occupy (L1 raised to 18 MiB for Part B components and ramps). */
export const ATLAS_LEVEL_BUDGET_BYTES: Readonly<Record<AtlasLevel, number>> = Object.freeze({ 1: 18 * MiB, 2: 64 * MiB, 3: 128 * MiB });

/** Shared decoded and GPU atlas cap: the retained level-1 baseline plus the two larger levels (210 MiB) with headroom. */
export const ATLAS_CAP_BYTES = 256 * MiB;

export function assertAtlasLevelBudget(level: AtlasLevel, decodedBytes: number): void {
  const budget = ATLAS_LEVEL_BUDGET_BYTES[level];
  if (decodedBytes > budget) throw new Error(`atlas level ${level} decodes to ${decodedBytes} bytes, over its ${budget}-byte budget`);
}
